'use client';

import React from 'react';
import { useTranslation } from 'next-i18next';
import { PremiumDiscountBoxes } from '@components/features/cards/employer/PremiumDiscountBoxes';
import { useSwrAccountDiscountData } from '@hooks/useSwrApi/endpoints/order/useSwrAccountDiscountData';

// Interface
// *****************************************************
interface TalentPremiumUpgradeProps {
  className?: string;
  locale: Locale;
}

export const TalentPremiumUpgrade = (props: TalentPremiumUpgradeProps) => {
  // Destructure props
  const { className = '', locale } = props;
  const { data: accountDiscountData } = useSwrAccountDiscountData({ locale });
  // Translation
  const { t } = useTranslation('common');
  // Ensure boolean
  const hasPremium = !!accountDiscountData?.currentDiscountPercentage;

  // Render component
  // *****************************************************
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="relative col-span-2 rounded-l-3xl bg-gradient-to-r from-secondary/40 to-surface p-2">
        {/* Title */}
        <h3 className="ml-5 px-3 pt-1 text-left text-lg font-bold">
          {hasPremium
            ? t('consultant.info.card.title.with.subscription')
            : t('consultant.info.card.title')}
        </h3>

        {/* Description */}
        <div className="mb-2 ml-5 px-3 text-left text-sm">
          {hasPremium
            ? t('consultant.info.card.desc')
            : t('consultant.info.card.benefits')}
        </div>

        {/* Discount boxes */}
        <div className="rounded-l-3xl bg-surface p-4">
          <PremiumDiscountBoxes
            currentDiscountPercentage={
                accountDiscountData?.currentDiscountPercentage
              }
            isAuth
          />
        </div>
      </div>
    </div>
  );
};
